import { useState, useEffect } from 'react';
import { navItems } from '@/mocks/home';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[64px] md:h-[72px]">
          <a href="#" className="flex items-center gap-2 group" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 flex items-center justify-center flex-shrink-0">
              <i className="ri-play-circle-fill text-background-50 text-xl md:text-2xl"></i>
            </div>
            <span className="text-lg md:text-xl font-bold text-foreground-900 whitespace-nowrap group-hover:text-primary-600 transition-colors">
              91视频网站
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            <a
              href="#"
              onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors rounded-md whitespace-nowrap"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors rounded-md whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/70 pb-4 pt-2 bg-background-50/95 backdrop-blur-md">
            <nav className="flex flex-col gap-1">
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); setMobileOpen(false); }}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-background-100 rounded-md transition-colors"
              >
                首页
              </a>
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                  className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-background-100 rounded-md transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}